/**
 * Alice in Bloom — falling petals (fixed & visible)
 */
(function () {
  'use strict';

  var MAX_PETALS = 18;
  var active = 0;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function randomBetween(min, max) {
    return min + Math.random() * (max - min);
  }

  function spawnPetal(layer) {
    if (active >= MAX_PETALS) return;

    var petal = document.createElement('span');
    petal.className = 'aib-falling-petal';
    petal.setAttribute('aria-hidden', 'true');

    var left = randomBetween(1, 99);
    var duration = randomBetween(10, 18);
    var delay = randomBetween(0, 1);
    var size = randomBetween(10, 18);

    petal.style.left = left + 'vw';
    petal.style.setProperty('--aib-fall-duration', duration + 's');
    petal.style.setProperty('--aib-fall-delay', delay + 's');
    petal.style.setProperty('--aib-fall-size', size + 'px');
    petal.style.setProperty('--aib-fall-drift', randomBetween(-60, 60) + 'px');

    layer.appendChild(petal);
    active++;

    window.setTimeout(function () {
      if (petal.parentNode) petal.parentNode.removeChild(petal);
      active--;
    }, (duration + delay) * 1000 + 400);
  }

  function init() {
    if (prefersReducedMotion()) return;

    var layer = document.createElement('div');
    layer.className = 'aib-falling-petals-layer';
    layer.setAttribute('aria-hidden', 'true');
    document.body.appendChild(layer);

    // Spawn a burst on load so petals are immediately visible
    for (var i = 0; i < 8; i++) {
      (function(idx) {
        window.setTimeout(function() { spawnPetal(layer); }, idx * 400);
      })(i);
    }

    // Then keep spawning continuously
    function schedule() {
      spawnPetal(layer);
      window.setTimeout(schedule, randomBetween(800, 2000));
    }
    window.setTimeout(schedule, 3500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
